/** @jsx jsx */
import { jsx } from "theme-ui"
import styled from "styled-components"
import theme, { rem } from "@src/theme"

const TextArea = ({
  value,
  label,
  name,
  onChange,
  error,
  onBlur,
  required,
  small = false,
}) => {
  return (
    <label
      htmlFor={name}
      sx={{
        display: "block",
      }}
    >
      {label && (
        <Label as="span">
          {label}
          {required && "*"}
        </Label>
      )}

      <Outer
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        small={small}
      />
      {error && <p sx={{ color: "rainbowRed", mt: 1, mb: 0 }}>{error}</p>}
    </label>
  )
}

export default TextArea

const Label = styled.span`
  display: block;
  font-size: ${rem(18)};
  margin-bottom: ${rem(14)};
  font-family: ${theme.fonts.heading};
  font-weight: 900;
  /* text-transform: uppercase; */
`

const Outer = styled.textarea`
  border: 3px solid ${theme.colors.grey};
  padding: ${rem(8)};
  font-size: ${rem(18)};
  width: 100%;
  height: ${props => (props.small ? rem(125) : rem(250))};
  font-family: ${theme.fonts.body};
  border-radius: 0;
  color: ${theme.colors.darkPurple};
`
